import {Component, OnInit} from '@angular/core';
import {FormGroup, UntypedFormGroup} from "@angular/forms";
import {FormlyFieldConfig} from "@ngx-formly/core";
import {NzMessageService} from "ng-zorro-antd/message";
import {Admission} from "../model";
import {Router} from "@angular/router";
import {AdmissionService} from '../admission.service';
import {localhostMode} from "../../@core/session.service";
import {cloneDeep} from "lodash-es";

@Component({
  selector: 'app-appl-form',
  templateUrl: './appl-form.component.html',
  styleUrls: ['./appl-form.component.css']
})
export class ApplFormComponent implements OnInit {

  firstUser = true;
  adm!: Admission;
  form: UntypedFormGroup = new FormGroup<any>({});
  fields: FormlyFieldConfig[] = [];
  model: any = {};
  viewOnly = false;
  loading = false;

  constructor(private msg: NzMessageService,
              private appl: AdmissionService,
              private router: Router) {
    this.adm = this.appl.currentAdm;
    this.viewOnly = this.router.url.indexOf('/summary') > -1;
  }

  ngOnInit(): void {
    this.model = this.adm!.application.form;
    if (!!this.adm.application.submitted_ref) {
      this.firstUser = false;
    }
    if (this.viewOnly) {
      this.model.declaration = true;
    }
    this.fields = cloneDeep(this.adm!.formly_conf);
  }

  get TCUrl() {
    return this.adm.variables.tc_url;
  }

  async save() {
    this.loading = true;
    try {
      if (this.form.invalid) {
        this.form.markAllAsTouched();
        this.msg.warning('Please fill in the required filed');
        return;
      }
      await this.appl.upsert(this.form.value);
      this.msg.success('Save successfully');
      await this.router.navigate(['apply']);
    } finally {
      this.loading = false;
    }
  }

  checked() {
    this.firstUser = false;
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  back() {
    this.appl.backToPanel();
  }

  edit() {
    this.router.navigate(['/form']).then(() => {
      window.scrollTo({top: 0, behavior: 'smooth'});
    });

  }
}
